"use client";

import { useAuthContext } from "@/context/AuthContext";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import AanmeldFormNative from "@/containers/forms/inloggen/AanmeldForm.native";
import { PremiumHomeHero } from "./PremiumLanding";

export default function NativeLanding() {
  const { userData, isParent } = useAuthContext();
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (isParent && userData) {
      const queryString = searchParams.toString();
      router.replace(queryString ? `/ouders?${queryString}` : "/ouders");
    }
  }, [isParent, userData, router, searchParams]);

  if (isParent && userData) return null;

  if (userData) {
    return (
      <main className="flex-1 overflow-y-auto bg-achtergrond">
        <PremiumHomeHero
          centerStartCard
          includeFeedback={false}
          includeDiscovery={false}
          showStartLogo
        />
      </main>
    );
  }

  return <AanmeldFormNative />;
}
